/**
 * Portal Manta · CronoPage
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V, fmtMi } from '../../globals.js';

const CronoPage = memo(function CronoPage_Inner({lote}){
  const crono=lote.cronograma||[];
  const total=crono.reduce((s,c)=>s+(c.v||0),0);
  const maxC=Math.max(...crono.map(c=>c.v||0),1);
  return(<div style={{padding:'14px 17px',overflowY:'auto',flex:1}}>
    <div style={{fontSize:14,fontWeight:700,color:V.br,marginBottom:4}}>Cronograma de Investimento</div>
    <div style={{fontSize:10.5,color:V.g4,marginBottom:14}}>MEF · Data-base {lote.data_base} · Total: {fmtMi(total)}</div>
    <div style={{background:'#fff',border:`1px solid ${V.g2}`,borderRadius:12,padding:'16px 20px'}}>
      {crono.map(c=>{
        const w=Math.max(3,Math.round(((c.v||0)/maxC)*100));
        return(<div key={c.ano} style={{display:'flex',alignItems:'center',gap:10,marginBottom:8}}>
          <span style={{width:38,fontSize:11,fontWeight:600,color:V.g5,flexShrink:0}}>{c.ano}</span>
          <div style={{flex:1,height:22,background:V.g1,borderRadius:4,overflow:'hidden'}}>
            <div style={{width:`${w}%`,height:'100%',background:V.or,borderRadius:4,display:'flex',alignItems:'center',justifyContent:'flex-end',paddingRight:8,boxSizing:'border-box'}}>
              {w>25&&<span style={{fontSize:10,fontWeight:700,color:'#fff'}}>{(c.v||0).toFixed(0)}</span>}
            </div>
          </div>
          <span style={{width:60,fontSize:11,fontWeight:600,color:V.g7,textAlign:'right',fontFamily:'monospace',flexShrink:0}}>{fmtMi(c.v)}</span>
        </div>);
      })}
    </div>
  </div>);});

export { CronoPage };
export default CronoPage;
